module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.screenSizeIsTooSmall) ? _c('div', {
    staticClass: "row editor"
  }, [_c('div', {
    staticClass: "menu editor-column col-md-3 col-lg-3 col-xl-3"
  }, _vm._l((_vm.internalDragElements), function(section) {
    return _c('div', {
      key: section.title
    }, [_c('h4', [_vm._v("\n        " + _vm._s(section.title) + "\n      ")]), _vm._v(" "), _c('drag-container', {
      attrs: {
        "groupName": "menu-default",
        "shouldRemoveOnDrop": false,
        "shouldAcceptDrops": false,
        "dragClass": _vm.dragClass,
        "showTabs": _vm.showTabs,
        "collectionDrag": _vm.cleanSectionItems(section.items, _vm.internalStructure),
        "collection": _vm.internalStructure,
        "collectionByTab": _vm.internalStructureByTab
      },
      on: {
        "onDrop": _vm.onDrop
      }
    }, _vm._l((_vm.cleanSectionItems(section.items, _vm.internalStructure)), function(item, idx) {
      return _c('EditorDragItem', {
        key: ((item.name) + "-" + idx),
        attrs: {
          "size": "small",
          "item": item
        }
      })
    }), 1)], 1)
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "editor-column col-md-5 col-lg-5 col-xl-5"
  }, [(_vm.showTabs && _vm.tabsAvailable()) ? _c('drag-tab-container', {
    attrs: {
      "tabs": _vm.internalTabs,
      "editorName": _vm.editorName
    }
  }) : _vm._e(), _vm._v(" "), _c('drag-container', {
    class: _vm.getMainDragContainerClass(_vm.editorName),
    attrs: {
      "groupName": "getGroupName()",
      "shouldRemoveOnDrop": true,
      "shouldAcceptDrops": true,
      "dragClass": _vm.dragClass,
      "showTabs": _vm.showTabs,
      "collection": _vm.internalStructure,
      "collectionByTab": _vm.internalStructureByTab
    },
    on: {
      "onDrop": _vm.onDrop
    }
  }, [_vm._l((_vm.internalStructureItems()), function(item, idx) {
    return _c('EditorDragItem', {
      key: ((item.name) + "-" + idx),
      class: _vm.getItemGrid(item, _vm.editorName),
      attrs: {
        "size": "big",
        "item": item,
        "setActiveOnClick": true
      }
    })
  }), _vm._v(" "), (_vm.internalSubmitButton) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "drag-submit-button",
    class: {
      'active': _vm.submitButtonIsActive
    },
    on: {
      "click": _vm.setSubmitActive
    }
  }, [_c('drag-submit-button', {
    attrs: {
      "button": _vm.internalSubmitButton
    }
  })], 1)])]) : _vm._e()], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "editor-column active-container col-md-4 col-lg-4 col-xl-4"
  }, [_c('drag-active-item-container', {
    attrs: {
      "editorName": _vm.editorName,
      "limitEditing": _vm.limitEditing
    },
    on: {
      "delete": _vm.deleteElement,
      "edit": _vm.editElement
    }
  })], 1)]) : _c('div', [_c('empty-state', {
    attrs: {
      "heading": _vm.emptyStateOptions.heading,
      "subtitle": _vm.emptyStateOptions.subtitle
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f849f41","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/helpers/DragNDrop/Editor.vue
// module id = 1958
// module chunks = 0